import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Will4HelpSectionCta } from "../will4-help/will4-help-section.component";

export interface Will4LegacyHelpItem {
	imageSrc: string;
	imageAlt: string;
	title: string;
	description: string;
	reverse?: boolean;
}

@Component({
	selector: "app-will4-legacy-help-section",
	templateUrl: "./will4-legacy-help-section.component.html",
	styleUrls: ["./will4-legacy-help-section.component.scss"],
})
export class Will4LegacyHelpSectionComponent {
	@Input() title = "";
	@Input() items: Will4LegacyHelpItem[] = [];
	@Input() cta: Will4HelpSectionCta | null = null;
	@Output() ctaClick = new EventEmitter<Will4HelpSectionCta>();

	onCtaClick(): void {
		if (!this.cta) {
			return;
		}

		this.ctaClick.emit(this.cta);
	}
}
